import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SwipeableDrawer,
  Button,
  Typography,
  Box,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Langs from "../../../app/lang/langs";
import { generateMapByKey, checkPermission } from "../../../app/utils/helpers";
import { config } from "../../../app/utils/config";
import ExcelManager from "../../../app/managers/excelManager";
import moment from "moment";

export function MobileExportModal({ show, onHide }) {
  const dispatch = useDispatch();

  const planningList = useSelector((state) => state.planning.planningList);
  const collabs = useSelector((state) => state.collabs.list);
  const teams = useSelector((state) => state.teams);
  const selectedView = useSelector((state) => state.planning.selectedView);
  const selectedDate = useSelector((state) => state.planning.selectedDate);
  const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds);
  const sampleShifts = useSelector((state) => state.sampleShifts.list);
  const sampleLeaves = useSelector((state) => state.sampleLeaves.list);

  function isManager(teamId) {
    return checkPermission(config.scopes.shifts, config.permissionTypes.edit, teamId);
  }

  function getTeamLabelFromId(teamId) {
    let label = "";
    let teamsFiltered = teams.list && teams.list.filter((t) => t.id == teamId);
    if (teamsFiltered && teamsFiltered[0]) {
      label = teamsFiltered[0].label;
    }
    return label;
  }

  function handleExportPlanning() {
    if (!selectedTeamsIds.some((id) => isManager(id))) return;
    let samplesTypesMap = sampleLeaves
      .concat(sampleShifts)
      .reduce((obj, current) => {
        if (!obj[current.type] && current.task) {
          obj[current.type] = current.task;
        } else if (!obj[current.type] && current.description) {
          obj[current.type] = current.description;
        }
        return obj;
      }, {});

    let collabsMap = generateMapByKey(collabs, "id");
    let exportData = planningList.reduce((array, current) => {
      let collab = collabsMap[current.id_collab];
      if (collab) {
        let shiftData = {
          Nom: collab.nom || "",
          Prénom: collab.prenom || "",
          Email: collab.email || "",
          Type: current.type,
          "Type valeur": current.absent
            ? "Abs Inj"
            : samplesTypesMap[current.type] || current.type,
          Planning: current.task || "",
          Statut: current.status || "",
          Client: current.id_team_delegate
            ? getTeamLabelFromId(current.id_team_delegate)
            : getTeamLabelFromId(current.id_team),
          Début: moment(current.from, "x").format("HH:mm DD-MM-YYYY") || "",
          Fin: moment(current.to, "x").format("HH:mm DD-MM-YYYY") || "",
          Créé: current.createdAt
            ? moment(current.createdAt, "x").format("HH:mm DD-MM-YYYY")
            : "",
          "Créé par": current.createdBy || "",
          "Validé par": current.validatedBy || "",
          Commentaires: current.description || "",
        };
        array.push(shiftData);
      }
      return array;
    }, []);

    let formattedDate = `mois_${moment(selectedDate).format("MM_YYYY")}`;
    if (selectedView == "WEEKLY") {
      formattedDate = `semaine_${moment(selectedDate).format("WW_YYYY")}`;
    }
    ExcelManager.getInstance().generateAndDownloadExcelFromData(
      exportData,
      `Planning_${formattedDate}`
    );
    onHide();
  }

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={show}
      onClose={onHide}
      onOpen={() => {}}
      disableSwipeToOpen
      sx={{ zIndex: 1400 }}
      PaperProps={{
        sx: {
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
          px: 3,
          // Bottom sheet: the action row would otherwise sit under the home indicator.
          pb: "calc(24px + env(safe-area-inset-bottom, 0px))",
          pt: 1,
          maxHeight: "70dvh",
        },
      }}
    >
      {/* Handlebar */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          py: 1,
          mb: 1,
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 4,
            borderRadius: 2,
            backgroundColor: "grey.400",
          }}
        />
      </Box>

      {/* Title */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <FileDownloadIcon sx={{ color: "#FF9015", fontSize: 28 }} />
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          <Langs str="Export planning" />
        </Typography>
      </Box>

      {/* Content */}
      <Typography variant="body1" sx={{ mb: 3 }}>
        <Langs str="EXPORT_VALIDATION_MSG" />
      </Typography>

      {/* Actions */}
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          variant="outlined"
          onClick={onHide}
          sx={{
            flex: 1,
            borderRadius: "999px",
            minHeight: 48,
            textTransform: "none",
            fontWeight: 600,
            color: "text.secondary",
            borderColor: "divider",
          }}
        >
          <Langs str="CANCEL" />
        </Button>
        <Button
          variant="contained"
          onClick={handleExportPlanning}
          sx={{
            flex: 1,
            borderRadius: "999px",
            minHeight: 48,
            textTransform: "none",
            fontWeight: 600,
            backgroundColor: "#FF9015",
            "&:hover": { backgroundColor: "#e6820d" },
            "&:active": { transform: "scale(0.97)" },
          }}
        >
          <Langs str="Export" />
        </Button>
      </Box>
    </SwipeableDrawer>
  );
}
